// Messages
export const
    MSG_CLEAR_CANVAS_CONFIRM = 'Are you sure you want to clear the canvas?'
;